<template>
  <v-card
    :dark="true"
    color="primary"
  >
    <BaseLoader v-if="loading" />
    <div
      v-else
      class="d-flex pa-3 pa-md-5"
      :class="$vuetify.breakpoint.mobile ? 'flex-column' :'justify-space-between'"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''">
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Prix moyen
          </span>
          <span
            v-if="contrat.prixMoyenEnEuroParTonne"
            class="chiffre white--text align-self-center"
          >{{ contrat.prixMoyenEnEuroParTonne | roundNumber }}
          </span>
          <span
            v-else
            class="chiffre white--text align-self-center"
          >
            -
          </span>
          <span class="titre-h4-bandeau align-self-center white--text mr-2 ml-1 ml-md-0"> €/t</span>
        </div>
      </div>
      <div
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div class="d-flex">
          <span
            v-if="contrat.poidsTotalVenduEnPourcentage"
            class="chiffre white--text align-self-center mr-2"
          >
            {{ contrat.poidsTotalVenduEnPourcentage | roundNumber }}
          </span>
          <span
            v-else
            class="chiffre white--text align-self-center mr-2"
          >
            -
          </span>
          <span class="titre-h4-bandeau white--text mr-2 align-self-center">% vendus</span>
          <v-tooltip
            v-if="contrat.poidsTotalVenduEnPourcentage == null"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon
                class="ml-1 align-self-center"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            Veuillez confirmer votre rendement sur la page Mes cultures.
          </v-tooltip>
        </div>
      </div>
      <div
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div>
          <span class="chiffre white--text">
            {{ contrat.nbContratsSansPrixDefinitif }}
          </span>
          <span class="titre-h4-bandeau white--text mr-2">contrat{{ contrat.nbContratsSansPrixDefinitif > 1 ? 's' : '' }} sans prix payé définitif</span>
        </div>

        <v-btn
          v-if="!$vuetify.breakpoint.mobile"
          class="px-3 pt-1"
          icon
          @click="isOpenDetail =!isOpenDetail"
        >
          <v-icon>{{ isOpenDetail ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>
      <div v-if="$vuetify.breakpoint.mobile">
        <div class="d-flex justify-center">
          <v-btn
            icon  
            @click="isOpenDetail =!isOpenDetail"
          >
            <v-icon>{{ isOpenDetail ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-divider v-if="isOpenDetail && !loading" />
    <div
      v-if="isOpenDetail && !loading"
      class="d-flex pa-3 pa-md-5"
      :class="$vuetify.breakpoint.mobile ? 'flex-column' :'justify-space-between'"
    >
      <div
        v-if="contrat.prixMoyenParTypeContrat['GESTION_DELEGUEE']"
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''">
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Gestion déléguée
          </span>
          <span
            class="chiffre white--text align-self-center"
          >
            {{ contrat.prixMoyenParTypeContrat['GESTION_DELEGUEE'] | roundNumber }}
          </span>
          <span class="titre-h4-bandeau align-self-center white--text ml-1 ml-md-0 mr-2"> €/t</span>
        </div>
      </div>
      <div
        v-if="contrat.prixMoyenParTypeContrat['PRIX_FERME_AVEC_OPTION']"
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div
          
          :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''"
        >
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Prix ferme avec option
          </span>
          <span
            
            class="chiffre white--text align-self-center"
          >
            {{ contrat.prixMoyenParTypeContrat['PRIX_FERME_AVEC_OPTION'] | roundNumber }}
          </span>

          <span class="titre-h4-bandeau align-self-center white--text ml-1 ml-md-0 mr-2"> €/t</span>
        </div>
      </div>
      <div
        v-if="contrat.prixMoyenParTypeContrat['PRIX_FERME_SANS_OPTION']"
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div
          
          :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''"
        >
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Prix ferme sans option
          </span>
          <span
            
            class="chiffre white--text align-self-center"
          >
            {{ contrat.prixMoyenParTypeContrat['PRIX_FERME_SANS_OPTION'] | roundNumber }}
          </span>

          <span class="titre-h4-bandeau align-self-center white--text ml-1 ml-md-0 mr-2"> €/t</span>
        </div>
      </div>
      <div
        v-if="contrat.prixMoyenParTypeContrat['FILIERE_SPECIFIQUE']"
        :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
        class="d-flex"
      >
        <div
          
          :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''"
        >
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Filière spécifique
          </span>
          <span
            class="chiffre white--text align-self-center"
          >
            {{ contrat.prixMoyenParTypeContrat['FILIERE_SPECIFIQUE'] | roundNumber }}
          </span>
          <span class="titre-h4-bandeau align-self-center white--text ml-1 ml-md-0 mr-2"> €/t</span>
        </div>
      </div>
      <div
        v-if="contrat.prixMoyenParTypeContrat['AUTRE']"
        :class="$vuetify.breakpoint.mobile ? 'mb-5 ' :'align-center'"
        class="d-flex"
      >
        <div :class="$vuetify.breakpoint.mobile ? 'd-flex justify-start w-100' :''">
          <span class="titre-h4-bandeau white--text mr-md-2 mr-auto align-self-center">
            Autre
          </span>
          <span
            class="chiffre white--text align-self-center"
          >
            {{ contrat.prixMoyenParTypeContrat['AUTRE'] | roundNumber }}
          </span>
          <span class="titre-h4-bandeau align-self-center white--text ml-1 ml-md-0 mr-2"> €/t</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import BaseLoader from '@/components/common/base-loader.vue'


export default {
  name: 'ResumeContrats',
  components: {BaseLoader},
  props: {
    contrat: {
      type: Object,
      default: () => { }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenDetail: false
    }
  }
}
</script>
